import React, { useEffect, useState } from 'react';
import GonderimDetayModal from '../GonderimDetayModal';
import { fetchParcaGonderimDetay } from '../../services/parcaGonderimService';

/**
 * Gönderim detayını API'den yükleyip GonderimDetayModal ile gösterir (stok akışı içi, nested).
 */
const StokGonderimDetayFetchModal = ({ gonderimId, onClose }) => {
  const [gonderim, setGonderim] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!gonderimId) return;
    let cancelled = false;
    setLoading(true);
    setError('');
    setGonderim(null);
    fetchParcaGonderimDetay(gonderimId)
      .then((res) => {
        if (cancelled) return;
        if (res?.basarili && res?.veri) {
          setGonderim(res.veri);
        } else {
          setError(res?.mesaj || 'Gönderim yüklenemedi');
        }
      })
      .catch((e) => {
        if (!cancelled) setError(e?.data?.mesaj || e?.message || 'Gönderim yüklenemedi');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [gonderimId]);

  if (!gonderimId) return null;

  if (loading) {
    return (
      <div className="modal-overlay gonderim-detay-modal gonderim-detay-modal--nested" onClick={onClose} role="presentation">
        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px', padding: '24px' }}>
          <p style={{ margin: 0, textAlign: 'center' }}>Gönderim yükleniyor…</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="modal-overlay gonderim-detay-modal gonderim-detay-modal--nested" onClick={onClose} role="presentation">
        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '420px', padding: '24px' }}>
          <div className="alert alert-danger" style={{ marginBottom: '12px' }}>{error}</div>
          <button type="button" className="secondary-btn" onClick={onClose}>
            Kapat
          </button>
        </div>
      </div>
    );
  }

  return <GonderimDetayModal gonderim={gonderim} onClose={onClose} nested />;
};

export default StokGonderimDetayFetchModal;
